import { FaturaAnaSayfaPage } from './../faturaislemleri/fatura-ana-sayfa/fatura-ana-sayfa';
import { CarisecPage } from './../faturaislemleri/carisec/carisec';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';

import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController } from 'ionic-angular';

/**
 * Generated class for the NakliyeFaturaGirisPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-nakliye-fatura-giris',
  templateUrl: 'nakliye-fatura-giris.html',
})
export class NakliyeFaturaGirisPage {
AracListesi = [];
tarih1: any;
AracListesi2 = [];
skip: number = 0;
take: number = 50;
CariListesi=[];
FaturaNo:any="";
Yon: any="";
GonderenFirma:any="";
Komisyon:number=0;
Aciklama:any="";
GirilenTutar:number=0;
Tahsilat:number=0;
aranan = "";
Cari: any = { ID: -1,AliciID:-1,SaticiID:-2,AliciAdi: "" , Definition_: "" ,FaturNo:"",Yon:"",Aciklama:"",GrupID:"",Tutar:"0",GonderenFirma:"",Komisyon:"0",Tahsilat:"0",Tarih:""};
Arac: any = { ID: -1, Definition_: "" };
AracGrup: any = { ID: -1, AracGrupAdi: "" };
Arac2: any = { ID: -1, Definition_: "" };
AracGrup2: any = { ID: -1, AracGrupAdi: "" };
  constructor(public navCtrl: NavController, 
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public modalCtrl: ModalController,
     public viewCtrl: ViewController, 
     public navParams: NavParams) {

      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
      this.tarih1 = localISOTime;
  }

  ionViewDidLoad() {
 this.AraclariYUkle();
  }

  AraclariYUkle()
  {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.ortak.StAyarGetir.CariListeSayisi.toString());
    formData.append("grupkodu", "2");
    this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.AracListesi = sonuc.SonucObject;
      this.AracListesi2=sonuc.SonucObject;
          
    })
  }
  // CarileriListele()
  //  {
  //   var formData = new FormData();
  //   formData.append("aranan", this.aranan);
  //   formData.append("skip", this.skip.toString());
  //   formData.append("take", this.ortak.StAyarGetir.CariListeSayisi.toString());
  //   formData.append("grupkodu", "-1");
  //   this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {
  //     var sonuc = <any>a;
  //     this.CariListesi = sonuc.SonucObject;
          
  //   })

  //  }
   carisec() {
    var modal = this.modalCtrl.create(CarisecPage);
    modal.onDidDismiss(a => {
      if (a != null) {
        this.Cari = a;
        if (this.Cari.ID > 1) {
        }
        else {
        }
      }
    });
    modal.present();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.FaturaNo == 0) {
      mesaj = mesaj + "Lütfen Fatura No Giriniz. <br/>";
    }
    if ( this.Arac.ID == "-1") {
      mesaj = mesaj + "Lütfen Araç Seçiniz. <br/>";
    }
    if ( this.Arac2.ID == "-1") {
      mesaj = mesaj + "Lütfen Grup Seçiniz. <br/>";
    }
    if ( this.Cari.ID == "-1") {
      mesaj = mesaj + "Lütfen Cari Seçiniz. <br/>";
    }

    if (this.GirilenTutar == 0) {
      mesaj = mesaj + "Lütfen Tutar Giriniz. <br/>";
    }
   
     

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }

  }
Kaydet()
{

  var formData = new FormData();
  if(this.boslukKontrol())
  {
    formData.append("Cari_json", JSON.stringify(this.Cari));
    formData.append("Alici_Json", JSON.stringify(this.Arac));
    formData.append("grupID", this.Arac2.ID);
    formData.append("grupAdi", this.Arac2.Definition_);
    formData.append("aliciID", this.Arac.ID);
    formData.append("aliciAdi", this.Arac.Definition_);
    formData.append("girilenTarih", this.tarih1);
    formData.append("faturaNo", this.FaturaNo);
    formData.append("aciklama", this.Aciklama);
    formData.append("girilenTutar", this.GirilenTutar.toString());
    formData.append("komisyon", this.Komisyon.toString());
    formData.append("yon", this.Yon);
    formData.append("yapilanTahsilat", this.Tahsilat.toString());
    formData.append("GonderenFirma", this.GonderenFirma);
 


    this.bllOrtak.islem(formData, "NakliyeFaturasiKaydet", "", false).then(a => {
      this.ortak.showBasicAlert("Uyarı", "İşlem Başarılı");
      this.navCtrl.setRoot(FaturaAnaSayfaPage);
     });
  }}
  kapat() {

    this.viewCtrl.dismiss();


  }
// }
}



// WEBPACK FOOTER //
// ./src/pages/nakliye-fatura-giris/nakliye-fatura-giris.ts